export const FINANCE_CONFIG = {
    projection: {
        importantThreshold: 100,
        maxYear: 2028,
        minYear: 2025,
        riskBalance: 500,
    },
    adviser: {
        cashDragThreshold: 5_000,
        emergencyFundMonths: 3,
        lowBalanceThresholdFactor: 0.5,
        recoveryDaysPerMonth: 30,
        savingsExcellentFactor: 0.3,
        savingsGoodFactor: 0.15,
        savingsHabitFactor: 0.2,
        savingsSuggestionFactor: 0.1,
        significantExpenseFactor: 0.2,
        spendingRiskFactor: 0.9,
        topExpenseCategoryFactor: 0.25,
        healthScore: {
            cautionMinimum: 40,
            criticalRatio: 0.95,
            healthyMinimum: 75,
            insolvencyPenalty: 60,
            lowBufferPenalty: 30,
            maximum: 100,
            negativeFlowRatio: 1,
            netFlowNegativePenalty: 50,
            ratioCriticalPenalty: 40,
            ratioWarning: 0.85,
            ratioWarningPenalty: 25,
        },
    },
};
//# sourceMappingURL=config.js.map